import { useState } from 'react';
import { useDebounce } from 'use-debounce';
import { Context } from './CompanyUserContext';
import { useGetCompanyUsers } from './useGetCompanyUsers';
// TODO MOVE TO WHERE USED
export function CompanyUserProvider(props) {
    const { children } = props;
    const [sort, setSort] = useState({ order: 'asc', id: 'name' });
    const [search, setSearch] = useState('');
    const [searching, setSearching] = useState(false);
    const [debouncedSearchValue, setDebouncedSearchValue] = useDebounce(search, 450);
    const { companyUsers, loading, error, initialLoading } = useGetCompanyUsers({
        sort,
        search: debouncedSearchValue,
    });
    if (searching && !loading) {
        setSearching(false);
    }
    const handleSearch = (value) => {
        setSearch(value);
        setDebouncedSearchValue(value);
        setSearching(true);
    };
    const noSearchResults = Boolean(search) && companyUsers.length < 1;
    return (<Context.Provider value={{
            sort,
            setSort,
            companyUsers,
            loading: initialLoading,
            error,
            setSearch: handleSearch,
            noSearchResults,
            searching,
            searchValue: search,
        }}>
      {children}
    </Context.Provider>);
}
